import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=01d0e7a5&scoped=true&"
import script from "./Home1.vue?vue&type=script&lang=js&"
export * from "./Home1.vue?vue&type=script&lang=js&"
import style0 from "./Home1.vue?vue&type=style&index=0&id=01d0e7a5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d0e7a5",
  null
  
)

export default component.exports